import { createFileRoute } from "@tanstack/react-router";
import { AbroadGuestStart } from "@/components/abroad/AbroadGuestStart";
import { guestStartHead } from "@/components/abroad/abroad-guest-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Старт подбора без кабинета (en). «_» после study-abroad — не вкладывать
// в лендинг: у него нет <Outlet/>, и вложенная страница не отрисовалась бы.
export const Route = createFileRoute("/en/study-abroad_/start")({
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => guestStartHead("en", loaderData),
  component: () => <AbroadGuestStart lang="en" />,
});
